<div>
  <img id="barcode" />
  <!-- <svg id="barcode"></svg> -->
</div>